module.exports = __webpack_public_path__ + "img/one_year_en.a32a8125.jpg";